import {IobrDataServerForRadarTrend} from "../../../pages/Fintech/FintechDashboard.type";
import {TitleCard} from "../styles";
import IconPotentionGrowActive from "../../../assets/icons/sorterByCard/active/globe.svg";
import IconDollarFlowerActive from "../../../assets/icons/sorterByCard/active/flower.svg";
import IconDollarZigzagActive from "../../../assets/icons/sorterByCard/active/zig-zag.svg";
import IconDollarQuadro from "../../../assets/icons/sorterByCard/active/icon-dollar_blue_card.svg";
import {BlockToggleDescriptionTehnology} from "../../InfoExpand/blockToggleDescriptionTehnology";
import {ITypeRadar} from "../../../types";
import {TitleBlockTrend} from "../SidebarCardUI/TitleBlockTrend";
import {BlockGraphLevelTrend} from "../SidebarCardUI/BlockGraphLevelTrend";
import ReactMarkdown from "react-markdown";
import {useEffect, useState} from "react";

interface IProps {
  data: IobrDataServerForRadarTrend;
  typeRadar?: ITypeRadar;
  colorTitle?: string;
}

const SideBarContentFintech: React.FC<IProps> = ({
  data,
  typeRadar,
  colorTitle,
}) => {
  const [showFullText, setShowFullText] = useState(false);

  useEffect(() => {
    setShowFullText(false);
  }, [data?.description]);

  if (!data) {
    return <>Грузим данные</>;
  }

  const toggleText = () => setShowFullText(!showFullText);

  const truncatedText =
    data?.description?.length > 400
      ? `${data.description
          .substring(0, 400)
          .split(" ")
          .slice(0, -1)
          .join(" ")} ...`
      : data?.description || "";

  return (
    <div>
      <TitleCard color={colorTitle}>{data.name}</TitleCard>
      <br />
      <div style={{color: "white"}}>
        <ReactMarkdown>
          {showFullText ? data?.description : `${truncatedText}`}
        </ReactMarkdown>
        {data?.description && data?.description?.length > 400 && (
          <p
            onClick={toggleText}
            style={{
              color: "#0f9fff",
              padding: "5px 0",
              cursor: "pointer",
            }}
          >
            {showFullText ? "Показать меньше" : "Показать больше"}
          </p>
        )}
      </div>

      <div>
        {(data.market_volume ||
          data.market_volume_forecast ||
          data.cagr ||
          data.venture_invest_volume) && (
          <>
            <br />
            <TitleBlockTrend title="Оценка тренда" tooltip="Оценка тренда" />
          </>
        )}

        {data.market_volume && (
          <>
            <br />
            <BlockGraphLevelTrend
              icon={IconPotentionGrowActive}
              title={"Объем мирового рынка 2024"}
              description={
                data.market_volume > 1000
                  ? `${parseFloat(
                      (data.market_volume / 1000).toFixed(2)
                    ).toString()} трлн $`
                  : `${data.market_volume} млрд $`
              }
            />
          </>
        )}
        {data.market_volume_forecast && (
          <>
            <br />
            <BlockGraphLevelTrend
              icon={IconDollarFlowerActive}
              title={"Прогноз объема мирового рынка (2029)"}
              description={
                data.market_volume_forecast > 1000
                  ? `${parseFloat(
                      (data.market_volume_forecast / 1000).toFixed(2)
                    ).toString()} трлн $`
                  : `${data.market_volume_forecast} млрд $`
              }
            />
          </>
        )}

        {data.cagr && (
          <>
            <br />
            <BlockGraphLevelTrend
              icon={IconDollarZigzagActive}
              title={"CAGR"}
              description={`${data.cagr} %`}
            />
          </>
        )}

        {data.venture_invest_volume && (
          <>
            <br />
            <BlockGraphLevelTrend
              icon={IconDollarQuadro}
              title={"Объем мировых венчурных инвестиций 2024"}
              description={
                data.venture_invest_volume > 1000
                  ? `${parseFloat(
                      (data.venture_invest_volume / 1000).toFixed(2)
                    ).toString()} трлн $`
                  : `${data.venture_invest_volume} млрд $`
              }
            />
          </>
        )}
      </div>
      <br />

      {data.maturity && (
        <>
          <br />
          <BlockToggleDescriptionTehnology
            data={data.maturity}
            title={<TitleBlockTrend title="Зрелость тренда" />}
            typeRadar={typeRadar}
          />
        </>
      )}

      {data.economics && (
        <>
          <br />
          <BlockToggleDescriptionTehnology
            data={data.economics}
            title={<TitleBlockTrend title="Экономика и рынок" />}
            typeRadar={typeRadar}
          />
        </>
      )}

      {data.drivers && (
        <>
          <br />
          <BlockToggleDescriptionTehnology
            data={data.drivers}
            title={<TitleBlockTrend title="Драйверы и барьеры" />}
            typeRadar={typeRadar}
          />
        </>
      )}

      {data.investments && (
        <>
          <br />
          <BlockToggleDescriptionTehnology
            data={data.investments}
            title={<TitleBlockTrend title="Инвестиции" />}
            typeRadar={typeRadar}
          />
        </>
      )}

      {data?.cases?.length > 0 && (
        <>
          <br />
          <BlockToggleDescriptionTehnology
            data={"data.cases"}
            title={<TitleBlockTrend title="Кейсы и сценарии применения" />}
            typeRadar={typeRadar}
          />
        </>
      )}

      {/* <br />
      <BlockToggleDescriptionTehnology
        data={data.fact}
        title={<TitleBlockTrend title="Факты" />}
        isOpen
        typeRadar={typeRadar}
      /> */}

      {/* <br />
      <BlockToggleDescriptionTehnology
        data={
          <BlockMaturityTrend
            data={data.metrics.trend_maturity_indicator}
            xIndicators={xIndicators}
          />
        }
        title={
          <TitleBlockTrend
            title="Зрелость тренда"
            tooltip={data.metrics.trend_maturity_indicator.desc}
          />
        }
        isOpen
        typeRadar={typeRadar}
      /> */}

      {/* <br />
      <BlockToggleDescriptionTehnology
        data={
          <BlockMaturityTrend
            data={data.metrics.economic_impact_indicator_}
            xIndicators={xIndicators}
          />
        }
        title={
          <TitleBlockTrend
            title="Экономическа и рынок"
            tooltip={data.metrics.economic_impact_indicator_.desc}
          />
        }
        typeRadar={typeRadar}
      /> */}

      {/* <br />
      <BlockToggleDescriptionTehnology
        data={
          <BlockMaturityTrend
            data={data.metrics.regulatory_readiness_indicator_}
            xIndicators={xIndicators}
          />
        }
        title={
          <TitleBlockTrend
            title="Регулируемость"
            tooltip={data.metrics.regulatory_readiness_indicator_.desc}
          />
        }
        typeRadar={typeRadar}
      /> */}

      {/* <br />
      <BlockToggleDescriptionTehnology
        data={
          <BlockMaturityTrend
            data={data.metrics.emerging_tech_development_indicator_}
            xIndicators={xIndicators}
          />
        }
        title={
          <TitleBlockTrend
            title="Инвестициии"
            tooltip={data.metrics.emerging_tech_development_indicator_.desc}
          />
        }
        typeRadar={typeRadar}
      /> */}

      {/* <br />
      <BlockToggleDescriptionTehnology
        data={
          <BlockMaturityTrend
            data={data.metrics.market_reach_indicator_}
            xIndicators={xIndicators}
          />
        }
        title={
          <TitleBlockTrend
            title="Масштабность и рыночный охват"
            tooltip={data.metrics.market_reach_indicator_.desc}
          />
        }
        typeRadar={typeRadar}
      /> */}

      {/* <br />
      <BlockToggleDescriptionTehnology
        data={
          <BlockMaturityTrend
            data={data.metrics["tech-driven_indicator"]}
            xIndicators={xIndicators}
          />
        }
        title={
          <TitleBlockTrend
            title="Частота использования технологий"
            tooltip={data.metrics["tech-driven_indicator"].desc}
          />
        }
        typeRadar={typeRadar}
      /> */}

      {/* <br />
      <BlockToggleDescriptionTehnology
        data={
          <BlockMaturityTrend
            data={data.metrics.implementation_cases_indicator}
            xIndicators={xIndicators}
          />
        }
        title={
          <TitleBlockTrend
            title="Количество внедренных кейсов"
            tooltip={data.metrics.implementation_cases_indicator.desc}
          />
        }
        typeRadar={typeRadar}
      /> */}

      <br />
      {/* <BlockToggleDescriptionTehnology
        data={<BlockCases dataCases={data.cases} />}
        title={<TitleBlockTrend title="Кейсы" />}
        typeRadar={typeRadar}
        isOpen
      /> */}
    </div>
  );
};
export default SideBarContentFintech;
